module.exports = __webpack_public_path__ + "static/media/cart-empty.d85f5cb1.png";